module.exports = __webpack_public_path__ + "static/media/pm.6999a852.svg";